import moment from "moment";

// Get visible note

export default (notes) => {
  return notes.sort((a, b) => {
    return a.createAt < b.createAt ? 1 : -1;
  });
};
